import {useTranslation} from "react-i18next";
import Button from "./Button";

import './InLayer.scss'
import {ReactElement} from "react";

type Props = {
  title: string
  children: ReactElement|string
  btnConfirmLabel?: string
  noButtons?: boolean
  btnCancel?: boolean
  btnCancelLabel?: string
  onConfirm?: () => void
  onCancel?: () => void
}

export default (props: Props) => {
  const {t} = useTranslation()

  const btnConfirmLabel = props.btnConfirmLabel || t('ok')

  const onClick = (e: any, confirmed: boolean) => {
    e.preventDefault()
    e.stopPropagation()

    if (confirmed) {
      props.onConfirm && props.onConfirm()
    } else {
      props.onCancel && props.onCancel()
    }
  }

  return (
    <div className={'in-layer in-confirm no-backdrop'}>
      <div className="background"></div>

      <div className="scroller">
        <div className="layer">
          <div className="header"></div>
          <div className="content">
            <h2 className="headline">
              {props.title}
            </h2>
            {props.children}
            {!props.noButtons ? (
              <div className="buttons">
                <Button onClick={e => onClick(e, true)} size={'lg'} primary>
                  {btnConfirmLabel}
                </Button>
                {props.btnCancel || props.btnCancelLabel ? (
                  <Button onClick={e => onClick(e, false)} size={'lg'}>
                    {/* Not hoisted beside t('ok'): `cancel` is in neither catalogue (RISKS.md/P2.37). */}
                    {props.btnCancelLabel || t('cancel')}
                  </Button>
                ) : null}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}